import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Descriptions, Col, Row, Flex, Form, Select, Drawer, Modal } from 'antd';
import OrderService from "services/order"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useParams } from 'react-router';
import { useApp } from 'contexts/app';
import ProductVariantService from "services/product_variant"
import CustomerService from "services/customer"

import { PlusSquareOutlined, EditOutlined } from "@ant-design/icons"
import InputNumber from "components/input-number"
import { toSearchText } from "utils/text"

import { useWorkSpace } from "contexts/workspace"
import _ from "lodash"


const service = new CustomerService();

const CustomerInfo = ({ id, open, onClose, onSave }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { showLoading } = useApp();
  const [form] = Form.useForm()
  useEffect(() => {
    setIsModalOpen(open)
    if (open) {
      if (!id)
        form.setFieldsValue({ full_name: "", phone: "", address: "", id: null })
      else {
        loadCustomer();
      }
    }

  }, [open])


  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const btnSaveClick = () => {
    form.submit();
  }
  const onFinish = async values => {
    showLoading(true);
    if (values.id) {
      var data = await service.update(values);
      if (data) {
        form.setFieldsValue(data);
        await onSave(data);
      }
    } else {
      var data = await service.create(values);
      if (data) {
        form.setFieldsValue(data);
        await onSave(data);
      }
    }

    showLoading(false);
    onClose();




  };

  const loadCustomer = async () => {
    var cus = await service.getByID(id);
    if (cus) {
      form.setFieldsValue(cus)
    } else {
      form.setFieldsValue({ full_name: "", phone: "", address: "", id: null })
    }
  }

  const onFinishFailed = values => {
    console.log("value", values)
  };



  return (
    <>

      <Modal
        title={id ? "Sửa khách hàng" : "Thêm khách hàng"}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={open}
        onOk={handleOk}
        onCancel={onClose}
        footer={<Space>
          <Button>Close</Button>
          <Button onClick={btnSaveClick} type='primary'>Save</Button>
        </Space>}
      >
        <Form layout='vertical' form={form}

          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >


          <Form.Item
            hidden
            name={"id"}

          >
            <Input />
          </Form.Item>


          <Form.Item
            label="Số điện thoại"
            name={"phone"}
            rules={[

              {
                required: true,
                pattern: /^[0-9]{10}$/,
                message: "Số điện thoại không đúng định dạng",

              },

              {
                validator: async (_, value) => {

                  return new Promise(async (r, e) => {
                    if (!value) {
                      r();
                      return;
                    }
                    if (value.length < 10) {
                      r();
                      return;
                    }

                    try {
                      var data = await service.getByPhone(value);
                      if (id && data.id != id) {
                        e(new Error('Số điện thoại này đã được dùng cho khách hàng khác'));
                        return;
                      }
                      if (!id && data) {
                        e(new Error('Số điện thoại này đã được dùng cho khách hàng khác'));
                        return;
                      }

                      // if (data.error) {
                      //   e(new Error('Số điện thoại này đã được đăng ký rồi. Bạn hãy dùng số điện thoại này để đăng nhập nhé'));
                      //   return;
                      // }
                      r();

                    } catch (error) {

                      //  e(new Error('Không thể kiểm tra số điện thoại'));
                    }

                  })




                },
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Họ  và tên"
            name={"full_name"}

          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Địa chỉ"
            name={"address"}

          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Ghi chú"
            name={"note"}

          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default CustomerInfo;